export const calendarSx = (theme) => ({
  "& .MuiPickersDay-root": {
    fontSize: "0.8rem",
    borderRadius: "8px",
  },

  "& .MuiPickersDay-root:hover": {
    backgroundColor: theme.palette.primary.main + "14", // light hover
  },

  "& .Mui-selected": {
    backgroundColor: `${theme.palette.primary.main} !important`,
    color: theme.palette.primary.contrastText,
  },

  "& .MuiPickersDay-today": {
    border: `1px solid ${theme.palette.primary.main}`,
  },
});


// assets/theme/commonDateInputStyle.js
export const dateInputBoxSx = {
  border: "1px solid #d1d5db",
  borderRadius: "6px",
  backgroundColor: "#ffffff",
  px: 1.2,
  py: 1,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  gap: 0.8,
  minHeight: "36px",
  transition: "all 0.2s ease",

  "&:hover": {
    borderColor: "primary.main",
    backgroundColor: "rgba(0,0,0,0.02)",
  },
};

export const dateInputTextSx = {
  fontSize: "0.88rem",
  color: "#63656c",
};
